'use client';

import { __assign } from '../../_virtual/_tslib.js';
import { createContext } from 'react';
import { initialSearchBar } from './index.js';
import { EForceControDropdown } from './types.js';
import { ACTIONS } from './actions.js';
import { ELanguage } from '../../Utils/constants.js';
import { deepCloneObject } from '../../TreeSelect/helpers.js';

var searchBarReducer = function (state, action) {
    var _a, _b, _c, _d, _e;
    var type = action.type;
    var clonedState = deepCloneObject(state);
    switch (type) {
        case ACTIONS.SHOW: {
            return __assign(__assign({}, state), { isShow: action.payload });
        }
        case ACTIONS.FORCE_CONTROL: {
            switch (action.payload) {
                case EForceControDropdown.CLOSE_ALL:
                    return __assign(__assign({}, state), { forceControllDropdown: EForceControDropdown.CLOSE_ALL, isBlurBackground: false, isShow: false, selectedSuggestionIndex: -1 });
                case EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT:
                    return __assign(__assign({}, state), { forceControllDropdown: EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT, isBlurBackground: true, isShow: true });
                case EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT:
                    return __assign(__assign({}, state), { isBlurBackground: true, isShow: true, forceControllDropdown: EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT });
                default:
                    return __assign({}, state);
            }
        }
        case ACTIONS.BLUR_BACKGROUND: {
            return __assign(__assign({}, state), { isBlurBackground: action.payload });
        }
        case ACTIONS.SET_KEYWORD: {
            return __assign(__assign({}, state), { keyword: action.payload });
        }
        case ACTIONS.SET_TOP_JOB_ITEM: {
            return __assign(__assign({}, clonedState), { topJobItem: action.payload });
        }
        case ACTIONS.SET_HIGHLIGHT_JOB: {
            return __assign(__assign({}, clonedState), { highlightJob: action.payload });
        }
        case ACTIONS.SET_FIRST_TIME_LOAD: {
            return __assign(__assign({}, state), { isLoaded: action.payload });
        }
        case ACTIONS.OPEN_DROP_DOWN: {
            return __assign(__assign({}, state), { isBlurBackground: true, isShow: true });
        }
        case ACTIONS.CLOSE_DROP_DOWN: {
            return __assign(__assign({}, state), { isBlurBackground: false, isShow: false, selectedSuggestionIndex: -1 });
        }
        case ACTIONS.SET_HOT_KEYWORDS: {
            return __assign(__assign({}, state), { hotKeywords: action.payload });
        }
        case ACTIONS.SET_SUGGESTIONS: {
            return __assign(__assign({}, state), { suggestions: action.payload });
        }
        case ACTIONS.UPDATE_SELECTED_SUGGESTION_INDEX: {
            var nextIndex = action.payload;
            var _f = clonedState.suggestions, suggestions = _f === void 0 ? [] : _f, keyword = clonedState.keyword;
            var isSuggest = ((_a = suggestions[nextIndex]) === null || _a === void 0 ? void 0 : _a.type) === 'suggest';
            var nextKeyword = isSuggest
                ? (_c = (_b = suggestions[nextIndex]) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.suggest
                : (_e = (_d = suggestions[nextIndex]) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.companyName;
            var updateKeyword = keyword;
            if (nextKeyword) {
                updateKeyword = nextKeyword;
            }
            return __assign(__assign({}, clonedState), { selectedSuggestionIndex: action.payload, keyword: updateKeyword, isLockedDebounce: true });
        }
        case ACTIONS.TOGGLE_LOCK_DEBOUNCE: {
            return __assign(__assign({}, state), { isLockedDebounce: action.payload });
        }
        case ACTIONS.SET_JOB_YOU_WILL_LOVE: {
            return __assign(__assign({}, state), { jobYouWillLove: action.payload });
        }
        case ACTIONS.SET_SEARCH_JOB_YOU_LOVE: {
            return __assign(__assign({}, state), { searchJobYouLove: action.payload });
        }
        case ACTIONS.SET_RECENT_KEYWORDS: {
            return __assign(__assign({}, state), { recentSearch: action.payload });
        }
        case ACTIONS.SET_LOCATIONS: {
            return __assign(__assign({}, state), { locations: action.payload });
        }
        default:
            console.error('Unknown type of Search Bar Reducer');
            return __assign({}, state);
    }
};
var SearchBarContext = createContext({
    state: initialSearchBar,
    props: {
        langCode: ELanguage.VI,
        isMobile: true,
        pageName: '',
        msBaseUrl: '',
        dataProvider: null,
        userId: 0,
        userIP: '::1',
        VNWAppId: '',
        responsiveStyle: 'fill',
        optionList: [],
        mode: 'staging',
        userJobFunction: []
    },
    t: function (text) {
        return text;
    },
    dispatch: function () { },
    search: function () { }
});

export { SearchBarContext, searchBarReducer };
//# sourceMappingURL=reducer.js.map
